











import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import {
  loadClasses,
  $classes,
  classesDropdownModule,
  setSelectedClass,
} from '@/pages/common/dropdowns/class/classes-dropdown.model'
import { DropdownItem } from '@/pages/common/types'

export default Vue.extend({
  components: {
    FilterDropdown,
  },
  effector: {
    $classes,
    ...classesDropdownModule.store,
  },
  methods: {
    ...classesDropdownModule.methods,
    onSelectItem(item: DropdownItem | null) {
      setSelectedClass(item)
      this.$emit('setItem', item ? item.name : null)
    },
  },
  mounted() {
    if (this.$classes.length === 0) loadClasses()
  },
})
